module.exports = __webpack_public_path__ + "static/media/gegenbauer-logo.69578dfb.svg";